import * as React from 'react'
import styled, { css } from 'styled-components'

import { BREAKPOINTS, styles as S } from '@ulule/owl-kit-components/next'

type TriptychProps = {
  description: React.ReactNode
  handlers?: {
    onClick: () => void
    onMouseEnter: () => void
    onMouseLeave: () => void
    onTouchStart: () => void
  }
  leftZone: React.ReactNode
  title: React.ReactNode
  className?: string
}

const DescriptionInfo = styled(S.copy.S.regular)`
  align-items: baseline;
  display: flex;
  margin-top: 1px;
  flex-wrap: wrap;

  @media screen and ${BREAKPOINTS.TABLET} {
    flex-wrap: nowrap;
  }
`

const RightColumn = styled.div<{ $centerSelf: boolean }>`
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${({ $centerSelf }) => {
    if ($centerSelf) {
      return css`
        align-self: center;
        margin-top: -10px;
      `
    }
  }}
`

const TriptychView = styled.div`
  align-items: flex-end;
  display: flex;
  margin-bottom: 25px;
  min-width: 130px;
  position: relative;
  white-space: nowrap;

  @media screen and ${BREAKPOINTS.MOBILE_M} {
    min-width: 160px;
  }

  ${S.tooltip.Tooltip} {
    bottom: 50px;
  }
`

function TriptychComponent({
  description,
  handlers,
  leftZone,
  title,
  className,
}: TriptychProps): React.ReactElement<TriptychProps> {
  return (
    <TriptychView
      onClick={handlers?.onClick}
      onMouseEnter={handlers?.onMouseEnter}
      onMouseLeave={handlers?.onMouseLeave}
      onTouchStart={handlers?.onTouchStart}
      className={className}
    >
      {leftZone}
      <RightColumn $centerSelf={!description}>
        {title}
        {description && <DescriptionInfo as="span">{description}</DescriptionInfo>}
      </RightColumn>
    </TriptychView>
  )
}

export const Triptych = styled(TriptychComponent)``
